import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useSession } from "./lib/session";
import { Layout } from "./components/Layout";
import { Spinner } from "./components/ui";
import Welcome from "./pages/Welcome";
import SignIn from "./pages/SignIn";
import Register from "./pages/Register";
import Demo from "./pages/Demo";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import Positions from "./pages/Positions";
import References from "./pages/References";
import StudentDirectory from "./pages/StudentDirectory";
import Admin from "./pages/Admin";
import Privacy from "./pages/Privacy";

const PUBLIC_PATHS = ["/", "/signin", "/register", "/demo", "/privacy", "/welcome"];

export default function App() {
  const { user, loading } = useSession();
  const location = useLocation();

  if (loading) return <Spinner label="Signing you in" />;

  if (!user) {
    return PUBLIC_PATHS.includes(location.pathname) ? (
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/register" element={<Register />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/privacy" element={<div className="mx-auto max-w-3xl px-4 py-12"><Privacy /></div>} />
      </Routes>
    ) : (
      <Navigate to="/signin" replace state={{ from: location.pathname }} />
    );
  }

  return (
    <Layout>
      <Routes>
        {/* Students and industry users have no dashboard. The student one was
            a checklist only useful before the first submission, now the
            unsubmitted-EOI banner on the positions page; the industry one was
            two tiles linking to pages already in the nav, and its only real
            content -- the awaiting-approval notice -- is on the positions page
            too. Staff and coordinators still land on a real summary. */}
        <Route
          path="/"
          element={user.role === "STUDENT" || user.role === "INDUSTRY"
            ? <Navigate to="/positions" replace />
            : <Dashboard />}
        />
        <Route path="/profile" element={<Profile />} />
        <Route path="/positions/*" element={<Positions />} />
        <Route path="/references" element={<References />} />
        <Route path="/students" element={<StudentDirectory />} />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="/privacy" element={<Privacy />} />
        {/* Both reachable while signed in: /demo to switch persona without
            signing out, /welcome to show the landing page during a walkthrough. */}
        <Route path="/demo" element={<Demo />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/signin" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
